import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { Button, Divider, CircularProgress } from '@material-ui/core'

import {
  Brightness1 as FullIcon,
  WarningRounded as WarningIcon,
  ChevronRightRounded as ArrowRightIcon,
} from '@material-ui/icons'

import { useTheme } from '@material-ui/core/styles'

import Typography from '../display/typography'

import useStyles from './buttonStatusStyle'

const ButtonStatus = (props) => {
  const theme = useTheme()
  const countDownDate = new Date('Jan 5, 2021 15:37:25').getTime()
  // const [timer, setTimer] = React.useState('00:00:00')

  let useStylesParams = {
    active: props.active,
  }
  const classes = useStyles(useStylesParams)

  // React.useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     var now = new Date().getTime()
  //     var distance = countDownDate - now
  //     var h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  //     var m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
  //     var s = Math.floor((distance % (1000 * 60)) / 1000)
  //     var hours = h > 0 ? (h < 10 ? '0' + h + ':' : h + ':') : '00:'
  //     var minutes = m > 0 ? (m < 10 ? '0' + m + ':' : m + ':') : '00:'
  //     var seconds = s > 0 ? (s < 10 ? '0' + s : s) : '00'
  //     setTimer(hours + minutes + seconds)
  //     if (distance < 0) {
  //       // document.getElementById("demo").innerHTML = "EXPIRED";
  //     }
  //   }, 1000)
  //   return () => clearInterval(intervalId)
  // }, [countDownDate])

  const renderButton = () => {
    return (
      <>
        <Button
          size={props.size}
          variant={props.variant}
          color={props.color}
          fullWidth={props.fullWidth}
          disabled={props.disabled}
          component={props.component}
          startIcon={
            <FullIcon
              style={{
                fontSize: 12,
                color: theme.palette.status[props.status],
              }}
            />
          }
          endIcon={
            props.loading && (
              <CircularProgress
                size={16}
                style={{
                  color: theme.palette.status[props.status],
                  position: 'absolute',
                  left: 15,
                  top: 12,
                }}
              />
            )
          }
          to={props.to}
          style={{
            justifyContent: 'flex-start',
            alignItems: 'center',
            color: props.active ? '#fff' : theme.palette.primary.secondary,
            fontWeight: 400,
            borderColor: theme.palette.divider,
            backgroundColor: props.active
              ? theme.palette.primary.secondary
              : '#fff',
          }}
          onClick={props.onClick}
        >
          {props.children}
          {props.more && (
            <ArrowRightIcon
              style={{
                position: 'absolute',
                right: 10,
                color: props.active && '#fff',
              }}
            />
          )}
        </Button>
      </>
    )
  }

  const renderPanel = () => {
    return (
      <>
        <div className={classes.panel} onClick={props.onClick}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <FullIcon
              style={{
                fontSize: 12,
                color: theme.palette.status[props.status],
                marginRight: 10,
              }}
            />
            {props.loading && (
              <CircularProgress
                size={16}
                style={{
                  color: theme.palette.status[props.status],
                  position: 'absolute',
                  marginLeft: -2,
                }}
              />
            )}
            <Typography
              variant="body1"
              style={{
                color: props.active ? '#fff' : theme.palette.primary.secondary,
              }}
            >
              {props.children}
            </Typography>
            {props.more && (
              <ArrowRightIcon
                style={{
                  position: 'absolute',
                  right: 25,
                  color: props.active && '#fff',
                }}
              />
            )}
          </div>
          {props.description && props.active && (
            <>
              <div style={{ height: 5 }} />
              <Divider />
              <div style={{ height: 5 }} />
              <Typography
                variant="body2"
                style={{
                  color: theme.palette.hover4,
                }}
              >
                {props.description}
              </Typography>
            </>
          )}
          <div></div>
          {/* <div style={{ height: 10 }} />
          <Divider />
          <div style={{ height: 10 }} />
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant='subtitle1' style={{ color: 'rgba(255,255,255,.5)' }}>{timer}</Typography>
            <WarningIcon style={{ fontSize: 20, color: theme.palette.status[props.status] }} />
          </div>
          <div style={{ height: 5 }} />
          <Typography variant='body2' style={{ color: 'rgba(255,255,255,.25)' }}>{props.text}</Typography> */}
        </div>
      </>
    )
  }

  return <>{renderPanel()}</>
}

export default ButtonStatus
